import { flag } from "components/providers/featureFlags/flagUtils";

export type FeatureFlags = typeof featureFlags;
export type FeatureFlagsWidened = Record<string, ReturnType<typeof flag[keyof typeof flag]>>;

export const featureFlags = {
    "Series Groups": flag.boolean(true),
    "Recently Viewed": flag.boolean(true),
    "Location Search": flag.enum(["30", "50", "100", "150"], "30"),
};
